import { MobilityConceptLogo } from "@App/Components/atoms/whitelabel/logos/MobilityConceptLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import { config as defaultConfig } from "@App/configs/default";
import type { Config } from "@App/configs/interfaces";
import { differenceInCalendarDays, subWeeks } from "date-fns";

export function canBook(contractEndDate: Date) {
  const earliestBookable = subWeeks(contractEndDate, 4);
  const diff = differenceInCalendarDays(earliestBookable, new Date());
  return diff < 40;
}

/**
 * The default configuration, used as a fallback and base for all other configurations.
 * Modify this config to change default values for all whitelabels.
 */
export const config: Partial<Config> = {
  slug: "mobility-concept",
  navbar: {
    logos: {
      left: {
        component: <MobilityConceptLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.mobility-concept.de/",
    },
  },

  contractDetails: {
    canBook: canBook,
  },

  reviews: {
    show: true,
  },
  checkout: {
    ...defaultConfig.checkout,
    contractNumber: {
      display: false,
      regex: /^[A-Za-z0-9]{6}$/,
    },
  },
};

export default config;
